import { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import logo from "../../../logo.png";
import ThemeToggle from "../theme-toggle";
import CountrySelector from "./countrySelector";
import LanguageSelector from "./languageSelector";
import Footer from "../footer/footer";
import { useTranslation } from "../../../i18n/useTranslation";

const Layout = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const NAV_LINKS = [
    { to: "/trusted-ecosystem", label: t("nav.trustedEcosystem") },
    { to: "/solutions", label: t("nav.solutions") },
    { to: "/markets", label: t("nav.markets") },
  ];

  const MenuIcon = ({ open }) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      {open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M3 6h18M3 12h18M3 18h18" />}
    </svg>
  );

  return (
    <>
      <header className="band-hero sticky top-0 z-50 transition-colors duration-200">
        <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center" onClick={() => setOpen(false)}>
            <img alt="Tapaswe Global" src={logo} width="40" height="40" className="block" />
          </Link>

          <nav className="hidden sm:flex items-center gap-6">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="nav-link">{l.label}</Link>
            ))}
            <CountrySelector />
            <LanguageSelector />
            <ThemeToggle />
          </nav>

          <div className="flex sm:hidden items-center gap-3">
            <CountrySelector />
            <LanguageSelector />
            <ThemeToggle />
            <button
              type="button"
              aria-label={open ? "Close menu" : "Open menu"}
              onClick={() => setOpen((o) => !o)}
              className="p-1"
            >
              <MenuIcon open={open} />
            </button>
          </div>
        </div>

        {open && (
          <nav className="sm:hidden flex flex-col px-5 pb-4 gap-3">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="nav-link" onClick={() => setOpen(false)}>
                {l.label}
              </Link>
            ))}
          </nav>
        )}
      </header>
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
